// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Modal/Footer" (14083:228176). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const modalFooterContract = {
    component: 'Modal/Footer',
    nodeId: '14083:228176',
    section: '[Web] Modals',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        {
            component: 'Button',
            variants: [
                'size=big, state=default, type=primary',
                'size=small, state=default, type=primary',
            ],
        },
    ],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: ['slot', 'slot-primary'] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        {
            note: 'primaryAxisAlignItems CENTER on a row that hugs — no slack to align in, so the file states an alignment it does not draw',
            count: 3,
            property: 'primaryAxisAlignItems',
            stated: 'CENTER',
        },
    ] as readonly ContractDisagreement[],
    textStyleIds: [],
    props: {
        'showButton': { kind: 'boolean' },
        'slot': { kind: 'slot' },
        'slot-primary': { kind: 'slot' },
        'variant': { kind: 'enum', values: ['big-buttons', 'small-buttons'] },
    },
    variants: {
        'variant=big-buttons': {
            container:
                'bg-background-sub-surface border-t border-t-border-subtle rounded-b-cards px-2xl py-m gap-m w-[53.75rem] items-center justify-end',
            label: '',
            icon: 'text-primary-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'slot': 'px-s py-s gap-s items-start',
                'buttons': 'gap-s items-start',
                'slot-primary': 'gap-s items-center',
                'Button':
                    'bg-primary-default rounded-common px-m py-s gap-xs h-[3rem] items-center',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [
                { component: 'Button', variants: ['size=big, state=default, type=primary'] },
            ],
        },
        'variant=small-buttons': {
            container:
                'bg-background-sub-surface border-t border-t-border-subtle rounded-b-cards px-2xl py-m gap-m w-[53.75rem] h-[3.625rem] items-center justify-end',
            label: '',
            icon: 'text-primary-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'slot': 'px-s py-s gap-s h-[2.5rem] items-start',
                'buttons': 'gap-s h-[2.5rem] items-center',
                'slot-primary': 'gap-s items-center',
                'Button': 'bg-primary-default rounded-common px-m gap-xs h-[2.5rem] items-center',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [
                { component: 'Button', variants: ['size=small, state=default, type=primary'] },
            ],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
